import React from "react";
import { formatAppointmentDate, formatAppointmentTime } from "../../utilities";

interface AppointmentTimeDisplayProps {
  /**
   * The appointment time string in ISO format
   */
  availableTime: string;
  /**
   * Optional name of the selected veterinarian
   */
  selectedVeterinarianName?: string;
  /**
   * The language code of the site, for date formatting
   */
  language: string;
}

/**
 * Component to display formatted appointment time with optional veterinarian name.
 * Uses visual dots to separate date, time, and veterinarian information.
 */
export const AppointmentTimeDisplay = ({
  availableTime,
  selectedVeterinarianName,
  language
}: AppointmentTimeDisplayProps) => {
  const date = formatAppointmentDate(availableTime, language);
  const time = formatAppointmentTime(availableTime);

  return (
    <>
      {date}
      <span className="inline-flex w-xxs h-xxs mx-xxs bg-turquoise-600 rounded-full" />
      {time}
      {selectedVeterinarianName && (
        <>
          <span className="inline-flex w-xxs h-xxs mx-xxs bg-turquoise-600 rounded-full" />
          {selectedVeterinarianName}
        </>
      )}
    </>
  );
};
